import styled from "styled-components";
import Icon from "../../../../../components/icon";
import { theme } from "../../../../../helpers/theme";
import { ReactComponent as ResignationIconSVG } from "../../../../../assets/icons/form-info.svg";

interface OfferViewHeaderProps {
    offer_number_label: string,
    offer_number: string,
}

export const OfferViewHeader = ({ offer_number_label, offer_number }: OfferViewHeaderProps) => {

    return (
        <Container>
            <NumerOfferWraper>
                <OfferLabel>{offer_number_label}:</OfferLabel>
                <OfferNumber>{offer_number}</OfferNumber>
            </NumerOfferWraper>
            <WraperInfo>
                <InfoLabel>{"Oferta została wysłana na twój adres e-mail"}</InfoLabel>
                <Icon
                    width="15px"
                    height="15px"
                    noPadding
                    icon={<ResignationIconSVG />}
                />

            </WraperInfo>
        </Container>
    );
};



const Container = styled.div`
display:flex;
flex-direction: row;
flex-wrap:wrap;
justify-content: space-between;
align-items:center;
margin-bottom:46px;
@media (max-width:770px) and (min-width: 260px){
flex-direction: column;
};
`;
const OfferLabel = styled.div`
font-family: ${theme.fonts.interRegular};
font-style: normal;
font-weight: ${theme.fontWeight.normal};
font-size: 14px;
line-height: 20px;
color:${theme.colors.black_primaryText};
padding-right:8px;
white-space: nowrap;
`;
const OfferNumber = styled.div`
font-family: ${theme.fonts.interRegular};
font-style: normal;
font-weight: ${theme.fontWeight.normal};
font-size: 14px;
line-height: 20px;
color:${theme.colors.black_primaryText};
`;
const InfoLabel = styled.div`
font-family: ${theme.fonts.interRegular};
font-style: normal;
font-weight:  ${theme.fontWeight.normal};
font-size: 14px;
line-height: 20px;
color: ${theme.colors.gray01_secondaryText};
padding-right:8px;
@media (max-width:770px){
    order:2;
    padding-left:8px;
    padding-right:0px;
}  
@media (max-width:410px){
    padding:0px;
    max-width: 220px;
};
`;
const WraperInfo = styled.div`
min-width:275px;
display:flex;
flex-direction:row;
align-items: center;

@media (max-width:770px) and (min-width:411px){
    margin-top:16px;
};
@media (max-width:410px){
    flex-direction:column;
    text-align: center;
    margin-top: 16px;
};
`;
const NumerOfferWraper = styled.div`
display:flex;
flex-direction:row;
@media (max-width:410px){
    flex-direction:column;
};
`;